/* @flow */
import ConfirmDialog from 'components/ConfirmDialog';
import GroupActions from 'groups/actions/GroupActions';
import Group from 'entities/Group';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';

type Props = {
  archiveFirst?: ?boolean,
  group: Group,
  onSubmit?: ?Function,
  onActionCompletion: Function,
  onRequestHide?: () => any,
  subText: string,
};

export default class ReuseClassConfirmDialog extends React.Component<Props> {
  handleSuccess = (group: Group) => {
    ToastActions.showSuccessToast(`New class created with code @${group.getCodeOrError()}`);
    this.props.onActionCompletion(group);
  };
  handleError = (error: Object) => {
    ToastActions.showErrorToast(error.message);
  };
  handleReuse = () => {
    const { group } = this.props;
    const orgId = group.getOriginalOrganizationId() || null;

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }

    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }

    return GroupActions.reuseGroup(group, orgId).then(this.handleSuccess, this.handleError);
  };

  handleArchiveAndReuse = () => {
    const { group } = this.props;
    const org = group.getOrganization();
    const orgId = org ? org.id : undefined;

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }

    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }

    return GroupActions.archiveAndReuseGroup(group, orgId).then(
      this.handleSuccess,
      this.handleError
    );
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="ReuseClassConfirmDialog"
        group={this.props.group}
        title="Reuse this class code?"
        subtext={this.props.subText}
        actionButtonText="Reuse"
        cancelButtonText="Cancel"
        preConfirmPromise={this.props.archiveFirst ? this.handleArchiveAndReuse : this.handleReuse}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}
